const labels = {
  inspectedBy: 'Inspected By',
  filterBy: 'FILTER BY',
  inspectedOn: 'Inspected On',
};

export { labels };
